import React from 'react';
import Product from './Product';

const Explore = () => {
    return (
        <div>
            <Product></Product>
        </div>
    );
};

export default Explore;